<template>
  <div class="button-editor">
    <!-- Contentタブ -->
    <div v-if="showTabContent" class="button-content">
      <ul>
        <!-- テキスト -->
        <li>
          <label>ボタン設定</label>
          <div class="textarea-wrapper"><textarea type="text" v-model="inputText"></textarea></div>
        </li>
        <!-- リンク -->
        <li>
          <edit-link
            :ids="ids"
            :attrs="attrs"
            :partsContainerType="partsContainerType"
          />
        </li>
      </ul>
    </div>
    <!-- Styleタブ -->
    <div v-if="showTabStyle">
      <!-- ボタンのスタイル -->
      <edit-button-style
        :value="styles"
        :width="attrs && attrs['width'] ? attrs['width'] : null"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partId="ids.partId"
        :partType="partType"
      />
      <!-- テキストのスタイル -->
      <edit-button-text-style
        :value="styles"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partId="ids.partId"
      />
    </div>
    <!-- 設定タブ -->
    <div v-if="showTabSetting">
      <edit-parts-container-style
        :styles="partsContainerStyles"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partsContainerType="partsContainerType"
      />
    </div>
  </div>
</template>

<script>
import EditButtonStyle from '@/components/Content/Palette/EditPartDesign/Editor/Button/ButtonStyle'
import EditButtonTextStyle from '@/components/Content/Palette/EditPartDesign/Editor/Button/ButtonTextStyle'
import EditLink from '@/components/Content/Palette/EditPartDesign/Layouts/EditLink'
import EditPartsContainerStyle from '@/components/Content/Palette/EditPartDesign/Layouts/PartsContainerStyle'

export default {
  props: [
    'current',
    'parts',
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'partsContainerStyles',
  ],
  components: {
    EditButtonStyle,
    EditButtonTextStyle,
    EditLink,
    EditPartsContainerStyle,
  },
  computed: {
    showTabContent () {
      return this.current.tab === 'Content'
    },
    showTabStyle () {
      return this.current.tab === 'Style'
    },
    showTabSetting () {
      return this.current.tab === 'Setting'
    },
    styles () {
      return this.parts[0].styles
    },
    attrs () {
      return this.parts[0].attrs
    },
    partType () {
      return this.parts[0].type
    },
    ids () {
      return {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.parts[0].id
      }
    },
    inputText: {
      get () {
        // bodyは改行コード>特殊文字の順番でデコード
        let body = this.$utils.string.sanitizeDecodeBr(this.parts[0].body)
        body = this.$utils.string.sanitizeDecode(body)
        return body
      },
      set (newValue) {
        // HTML タグを無効にするため、bodyは特殊文字>改行コードの順番でエンコード
        let body = this.$utils.string.sanitizeEncode(newValue)
        body = this.$utils.string.sanitizeEncodeBr(body)
        if (this.parts[0].body !== newValue) {
          this.$emit('input', {
            sectionId: this.sectionId,
            partsContainerId: this.partsContainerId,
            partId: this.ids.partId,
            body
          })
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.button-content {
  margin: 20px;
  label {
    display: block;
    margin-bottom: 20px;
  }
  .textarea-wrapper {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    border: 0.5px solid #c6c6c6;
    border-radius: 4px;
    background: #ffffff;
    display: inline-block;
    textarea {
      resize: none;
      width: 100%;
      appearance: none;
    }
  }
}
</style>

<style lang="scss">
.button-editor {
  .style-tab-button-text {
    .window {
      top: -275px;
      left: 0;
    }
  }
}
</style>
